export default "__VITE_ASSET__CjkszS91__"